import {useState} from "react";
import ButtonsText from "../../../../../../../components/Button/ButtonText";
import CustomDialog from "../../../../../../../components/Dialog/DiaComp";
import {TextDrugCodeine} from "./TextDrugCodeine"


export default function Codeine() {
    
    const [open, setOpen] = useState(false);
    const handleOpen = () => {setOpen(true);};
    const handleClose = () => {setOpen(false);};

return(
<>      
   
    <ButtonsText onClick={handleOpen} name='Codeine' size='large' color='common.white'   />
    <CustomDialog open={open} onClose={handleClose}

        title="Codeine - PGx Recommendation"
        content={ <TextDrugCodeine />}

        />

</>
)}